import { PersonTableRow } from '../store/info/types';
import { ReviewerTableRow } from '../store/bid/types';
import { TFunction } from 'i18next';
import { Role } from '../store/conference/types';
import { getRoleName } from './translations';
import { User } from '../store/user/types';

export const getReviewer = (
  personRoleId: number,
  users: {
    byId: { [key: number]: PersonTableRow };
    personRoleIdMap: { [key: number]: number };
  },
): ReviewerTableRow | undefined => {
  const person_id = users.personRoleIdMap[personRoleId];
  const reviewer = users.byId[person_id];
  if (!reviewer) return undefined;
  const index = reviewer.person_role_ids.findIndex((value) => value == personRoleId);
  return {
    ...reviewer,
    id: personRoleId,
    person_role_id: personRoleId,
    role_id: reviewer.role_ids[index],
  } as ReviewerTableRow;
};

export const getFullName = (author: { first_name: string; middle_name: string | null; last_name: string }): string => {
  return author.first_name + (author.middle_name ? ` ${author.middle_name}` : '') + ` ${author.last_name}`;
};

/**
 * Build display name
 * @param userRole
 * @param role
 * @param full_name
 * @param isYou
 * @param t
 * @param external_id
 * @param external_hash
 */
export const getUserAndRoleDisplayName = (
  userRole: Role,
  role: Role,
  full_name: string,
  isYou: boolean,
  t: TFunction<'translation', undefined>,
  external_id?: number,
  external_hash?: string,
): string[] => {
  let rolePart = '';
  let userPart = '';
  let hashPart = '';
  if (userRole.type == 'author') {
    rolePart = full_name;
  } else if (role.type == 'author') {
    rolePart = full_name;
    userPart = isYou ? t('(you)') : '';
  } else {
    rolePart = `${getRoleName(role, t)} ${external_id ? `#${external_id}` : ''}`;
    userPart = `${isYou ? t('(you)') : full_name ? full_name : ''}`;
    hashPart = external_hash ? `#${external_hash}` : '';
  }
  return [rolePart, userPart, hashPart];
};

export const isResearcherInfoCompleted = (user: User, role: Role): boolean => {
  const person = user.person;
  const isFieldMissing =
    (role.dblp_required && !person.dblp_key) ||
    (role.gscholar_required && !person.google_scholar_id) ||
    (role.orcid_required && !person.orcid_id);
  return !isFieldMissing;
};

export const stringifyOrganization = (obj: {
  organization: string | null;
  organization2: string | null;
  organization3: string | null;
  organization4: string | null;
  organization5: string | null;
}): string => {
  return [obj.organization, obj.organization2, obj.organization3, obj.organization4, obj.organization5]
    .filter((value) => !!value)
    .join('; ');
};
